import { FieldConfig } from "../Components/Form/FormComponent/types";

export const getCandidateFields = (
  assigneeOptions: string[],
): FieldConfig[] => [
  { name: "name", label: "Name", type: "text", required: false },
  { name: "phoneNumber", label: "Phone Number", type: "text" },
  { name: "email", label: "Email", type: "email" },
  { name: "position", label: "Position", type: "text" },
  {
    name: "experiences",
    label: "Experiences",
    type: "select",
    options: ["Yes", "No"],
  },
  {
    name: "location",
    label: "Location",
    type: "select",
    options: ["Subang 2", "Kuantan"],
  },
  {
    name: "qualification",
    label: "Qualification",
    type: "select",
    options: ["SPM", "Diploma", "Degree", "Master", "Others"],
  },
  {
    name: "status",
    label: "Status",
    type: "select",
    options: ["Pending", "Reviewed", "Accepted", "Rejected"],
  },
];
